<template>
    <div class="sub-serv-view">
        <HeaderComponent :title="'Serviços por Assinatura'" :showBackButton="true" />

        <div class="button-cont" @click="handleSign">
            <ButtonCenter :button="signButton" />
        </div>

        <div class="list-fields">
            <div v-for="(field, key) in fields" :key="key" class="list-field">
                <h1 v-text="field"></h1>
                <i class="fa fa-arrow-down icon" @click="orderServices(field)"></i>
            </div>
        </div>

        <div class="list" v-if="!isLoading && subscriptionServices?.length > 0" >
            <div class="list-line" v-for="(serv, key) in subscriptionServices" :key="key"
                :class="{ 'service-already-subscribed': serviceAlreadySubscribed(serv) }" >
                <!-- checkbox to inform weather the service is going to be signed or not -->
                <input type="checkbox" v-model="serv.selected" @change="updateSelectedServices(serv)">

                <div class="list-item" @click="serv.selected = !serv.selected; updateSelectedServices(serv)">
                    <div class="list-item-field">
                        <h1 class="schoolName" v-text="serv.NMSERVASS"></h1>
                    </div>
                    <div class="list-item-field">
                        <h1 class="value" v-text="formatValue(serv.VRNCSERVASS)"></h1>
                    </div>
                    <div class="list-item-field">
                        <h1 class="validity-dates" v-text="getValidityDates(serv)"></h1>
                    </div>
                    <div class="list-item-field status" v-if="serviceAlreadySubscribed(serv)">
                        <h1>Assinado</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="not-found" v-else-if="!isLoading">
            <h1>Não foram encontrados resultados</h1>
        </div>

        <div class="termVisibility" v-if="readTerms">
            <div class="termContainer" v-for="(term, key) in terms" v-show="term.hidden != true" :key="key" :id="'termFrame' + key" frameborder="0">
                <span @click="termClose(term)" >close</span>
                <iframe :src="term.url"></iframe>
            </div>
        </div>

        <SwipeModalComponent v-if="popupOpen" @closeMenu="this.popupOpen = false" class="swipe-modal">
            <div class="content-wrapper">
                <h2>Assinar Serviços</h2>

                <h2>Leia os <span @click="handleReadTerms">Termos e Condições</span></h2>

                <div class="buttons" >
                    <button @click="refuseSign">Recusar</button>
                    <button @click="acceptSign" :disabled="!readTerms">
                        Aceitar
                    </button>
                </div>
            </div>
        </SwipeModalComponent>

        <ScreenLoader :isLoading="isLoading"></ScreenLoader>
    </div>
</template>

<script>
import moment from 'moment'
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import SwipeModalComponent from '@/components/bottom-popups/SwipeModalComponent.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import { showAlertNotification, showSuccessNotification } from '@/libs/Util'
import { getSubscriptionServices, addSubscriptionService, getSubscribedServicesByConsumer } from '@/components/controllers/SubscriptionServicesController.js'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'SubscriptionServicesView',
    components: {
        HeaderComponent,
        ButtonCenter,
        SwipeModalComponent,
        ScreenLoader
    },
    data () {
        return {
            signButton: {
                display: 'Assinar Serviços',
                fill: false,
                action: this.confirmValues
            },
            fields: ['Serviço', 'Valor'],
            selectedServices: [],
            popupOpen: false,
            readTerms: false,
            terms: []
        }
    },
    created () {
        getSubscriptionServices()
        getSubscribedServicesByConsumer(this.getCurrDependent.CDCONSUMIDOR)
    },
    computed: {
        ...mapGetters(['subscriptionServices', 'isLoading', 'getCurrDependent', 'subscribedServicesByConsumer'])
    },
    methods: {
        ...mapActions(['startSubscriptionsLoading', 'stopSubscriptionsLoading']),
        formatValue (value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        getValidityDates (serv) {
            const startDate = moment(serv.DTVINGINI).format('DD/MM/YYYY')
            const endDate = moment(serv.DTVINGFIM).format('DD/MM/YYYY')
            return `De ${startDate} a ${endDate}`
        },
        updateSelectedServices: function (serv) {
            if (serv.selected) {
                this.selectedServices.push(serv)
            } else {
                this.selectedServices = this.selectedServices.filter(s => s.NRSERVASS !== serv.NRSERVASS)
            }
        },
        serviceAlreadySubscribed: function (serv) {
            const subscribedService = this.subscribedServicesByConsumer.find(element => element.NRSERVASS === serv.NRSERVASS)
            return subscribedService !== undefined
        },
        handleSign: function () {
            if (this.selectedServices.length === 0) {
                showAlertNotification({
                    title: '',
                    text: 'Selecione ao menos um serviço para assinar'
                })

                return
            }

            this.readTerms = false
            this.popupOpen = true
            this.terms = this.subscriptionServices.filter(s => s.selected === true && s.bs64).map(s => s.bs64)
            this.terms = new Set([...this.terms])
            this.terms = [...this.terms].map(t => {
                const service = this.subscriptionServices.find(st => st.bs64 === t)
                if (service) {
                    return { url: service.FILESERVERURL + service.URLARQTERMO, hidden: false }
                }
                return t
            })
        },
        termClose: function (term) {
            for (let i = 0; i < this.terms.length; i++) {
                const curTerm = this.terms[i]
                if (term.url === curTerm.url) {
                    term.hidden = true
                }
            }
        },
        refuseSign: function () {
            this.popupOpen = false
            showAlertNotification({
                title: '',
                text: 'Assinatura recusada'
            })
        },
        handleReadTerms: function () {
            this.readTerms = true
            for (let i = 0; i < this.terms.length; i++) {
                this.terms[i].hidden = false
            }
        },
        acceptSign: async function () {
            this.startSubscriptionsLoading()
            this.popupOpen = false
            const response = await addSubscriptionService(this.selectedServices, this.getCurrDependent)

            if (!response?.error) {
                showSuccessNotification({
                    title: '',
                    text: 'Assinatura realizada com sucesso'
                })

                this.$router.push('/dependent/invoiceSummary')
            } else {
                showAlertNotification({
                    title: '',
                    text: 'Não foi possível realizar a assinatura, tente novamente mais tarde'
                })
            }

            this.stopSubscriptionsLoading()
        },
        orderServices: function (field) {
            this.isSorted = !this.isSorted
            const sortingField = field === 'Serviço' ? 'NMSERVASS' : 'VRNCSERVASS'

            this.subscriptionServices.sort((a, b) => {
                if (this.isSorted) {
                    return a[sortingField] < b[sortingField] ? -1 : a[sortingField] > b[sortingField] ? 1 : 0
                } else {
                    return a[sortingField] > b[sortingField] ? -1 : a[sortingField] < b[sortingField] ? 1 : 0
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.sub-serv-view {
    position: relative;

    .button-cont {
        position: absolute;
        right: 0;

        button {
            width: 100%;
            padding: 0;
            margin-right: 25px;
        }
    }

    .list-fields {
        display: flex;
        justify-content: space-between;
        margin-top: 80px;
        padding: 0 4px;
        h1 {
            margin-bottom: 10px;
            font-weight: 600;
        }
        .list-field {
            display: flex;
            flex-direction: row;
            align-items: baseline;

            h1 {
                margin-right: 4px;
            }
        }
    }

    .list {
        height: calc(100vh - 157px);
        overflow-y: auto;

        &::-webkit-scrollbar {
            display: none;
        }

        .list-line {
            display: flex;

            input {
                margin-right: 20px;
            }
        }

        .service-already-subscribed.list-line {
            pointer-events: none;

            .list-item {
                background: rgb(240, 240, 240);
            }

            input {
                visibility: hidden;
            }
        }

        .status {
            align-self: center;
            display: flex;
            align-items: center;
            justify-content: center !important;
            padding: 5px 10px;
            border-radius: 5px;
            background: #70C169;

            h1 {
                font-size: 14px;
                font-weight: 600;
                color: #fff;
            }
        }

        .list-item {
            display: grid;
            grid-template-columns: 70% 30%;
            margin-top: 20px;
            padding-bottom: 20px;
            padding: 10px 10px;
            border: 1px solid rgba(0, 0, 0, 0.18);
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 5px;
            width: 100%;
            height: 65px;
            .list-item-field {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-content: center;
                align-items: center;
                &:nth-of-type(2n){
                    justify-content: end;
                }
                &:nth-of-type(3n){
                    // justify-content: end;
                }
            }
            .schoolName {
                max-width: 80%;
            }

            .validity-dates {
                font-size: .9rem;
            }
            &:last-of-type {
                margin-bottom: 20px;
            }
        }
    }

    .not-found, .loading {
        display: flex;
        justify-content: center;
        h1 {
            font-weight: 600;
        }
    }

    .swipe-modal {
        h2 {
            text-align: center;
            margin-top: 30px;

            span {
                color: var(--primaryColor);
            }
        }

        .buttons {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            margin-top: 20px;

            button {
                color: var(--primaryColor);
                padding: 10px 0;
                margin: 20px 15px;
                border: none;
                background-color: transparent;
                font-weight: bold;

                &:disabled {
                    color: #B4B4B4;
                }
            }
        }
    }
    .termContainer{
        background: white;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 10;
        span {
            position: relative;
            display: flex;
            margin: 10px 15px auto auto;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: flex-end;
        }
        iframe {
            position: fixed;
            bottom: 0;
            left: 0;
            height: calc(100vh - 50px);
            width: 95vw;
            right: 0;
            margin: auto;
        }
    }
}

</style>
